import React from 'react';
import { Box, styled } from '@mui/material';
import { defaultDesignToken } from 'designToken';
import { pxToRem } from 'MotifTheme';


const StyledBox = styled(Box)(({ theme }) => ({
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.info['x-dark'],
  color: theme.palette.common.white,
  fontFamily: defaultDesignToken.fontFamily[0],
  fontWeight: 700,
  fontSize: pxToRem(14),
  width: 'calc(100% - 138px)',
  alignSelf: 'flex-end',
}));

const StyledAnchor = styled('a')(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: 'none',
  marginLeft: theme.spacing(1),
}));

const LiveRampBanner = () => {
  // Show banner only on or after October 8, 2025
  const showBanner = new Date() >= new Date('2025-10-08T00:00:00');

  if (!showBanner) {
    return null;
  }

  return (
    <StyledBox>
      LiveRamp Clean Room Is Now in Connect.
      {' '}
      <StyledAnchor href='https://docs.liveramp.com/connect/en/announcement--clean-room-access-is-now-in-connect--10-8-25-.html' target='blank'>Learn more &rarr;</StyledAnchor>
    </StyledBox>
  );
};

export default LiveRampBanner;
